( () => {


	document.addEventListener( 'DOMContentLoaded', () => {

		// eslint-disable-next-line no-use-before-define
		getAQuoteForm.init()
	})


	/**
	 * Handles color-mixer-related functionality for the Get a Quote form
	 *
	 * @type {obj}
	 */
	const getAQuoteForm = {

		/**
		 * Kicks off functionality
		 *
		 * @return {void}
		 */
		init() {
			const url = new URL( window.location.href )
			const colorData = url.searchParams.get( 'color_data' )

			if ( colorData ) {
				this.parseColorData( colorData )
			}
		},


		/**
		 * Parse color data and populate form input
		 *
		 * @param {string} rawData Raw color data
		 * @return {void}
		 */
		parseColorData( rawData ) {
			let colorData

			try {
				colorData = decodeURI( rawData )
				colorData = window.atob( colorData )
				colorData = JSON.parse( colorData )
			} catch ( err ) {
				console.warn( `[Get a Quote Form] Encountered issue parsing color data: "${err}"` )
			}

			const input = document.querySelector( 'input[name="colors_selected"]' )
			if ( !input ) {

				// eslint-disable-next-line max-len
				console.warn( '[Get a Quote Form] Could not find input for color information: "input[name=\'colors_selected\']"' )
			}

			if ( Array.isArray( colorData ) && colorData.length ) {

				// needs to be under 100 characters for Eloqua to accept
				input.value = colorData.map( ({ c: code, p: percentage }) => `(${percentage})${code}` ).join( ',' )
			}
		},
	}


})()
